export const SET_REPORT_FILTER = 'SET_REPORT_FILTER';
export const SET_REPORT_FILTERS = 'SET_REPORT_FILTERS';
export const RESET_REPORT_FILTERS = 'RESET_REPORT_FILTERS';
export const SET_REPORT_SORTING = 'SET_REPORT_SORTING';
